2// ADIN Filter Component Engine V2
// Writer: Dorukhan Boncukçu
// Last Update: 11/03/2023

import Vue from 'vue'
import store from '@/store'

function FilterEngine () {
  const that = this
  this.config = {
    flags: {
      // ------------------
      isCampaignNecessary: false, // if this value is false,
      // the api request is only executed when a campaign that is different from default is selected.
      // ------------------
      transaction: true, // if this value is true,
      // the api request is only executed when a transaction that is different from default is selected.
      // ------------------
      allThings: true // if this value is false,
      // do not to permission to select all brands, all camping etc.
      // ------------------
    },

    getMetricsFunc: undefined
  }
  this.store = { // begin of the vuex store state action shortcuts
    set: { // begin of the SET actions
      campaign (val) {
        store.commit('filters/setSelectedCampaign', val)
      },
      brand (val) {
        store.commit('filters/setSelectedBrand', val)
      },
      date (val) {
        store.commit('filters/setSelectedDate', val)
      },
      objective (val) {
        store.commit('filters/setSelectedObjective', val)
      },
      domain (val) {
        store.commit('filters/setSelectedDomain', val)
      },
      seoBrand (val) {
        store.commit('filters/setSelectedSeoBrand', val)
      },
      seoMonth (val) {
        store.commit('filters/setSelectedSeoMonth', val)
      },
      event (val) {
        store.commit('filters/setSelectedEvent', val)
      },
      eventWeb (val) {
        store.commit('filters/setSelectedEventWeb', val)
      },
      growthEvent (val) {
        store.commit('filters/setSelectedGrowthEvent', val)
      },
      brandList (val) {
        store.commit('filters/setBrandList', val)
      },
      campaignList (val) {
        store.commit('filters/setCampaignList', val)
      },
      objectiveList (val) {
        store.commit('filters/setObjectiveList', val)
      },
      domainList (val) {
        store.commit('filters/setDomainList', val)
      },
      seoBrandList (val) {
        store.commit('filters/setSeoBrandList', val)
      },
      seoMonthList (val) {
        store.commit('filters/setSeoMonthList', val)
      },
      eventList (val) {
        store.commit('filters/setEventList', val)
      },
      eventWebList (val) {
        store.commit('filters/setEventWebList', val)
      },
      growthEventList (val) {
        store.commit('filters/setGrowthEventList', val)
      },
      isCampaignSelectionProper (val) {
        store.commit('filters/setIsCampaignSelectionProper', val)
      },
      isReady (val) {
        store.commit('filters/setIsReady', val)
      },
      isReadyMetrics (val) {
        store.commit('filters/setIsReadyMetrics', val)
      },
      mediaFormData (val) {
        store.commit('filters/setMediaFormData', val)
      },
      taxForm (val) {
        store.commit('filters/setTaxForm', val)
      },
      isEdit (val) {
        store.commit('filters/setIsEdit', val)
      },
      addTax (val) {
        store.commit('filters/setAddTax', val)
      },
      seoDate (val) {
        store.commit('filters/setSeoDate', val)
      },
      seoEvent (val) {
        store.commit('filters/setSeoEvent', val)
      },
      seoEventList (val) {
        store.commit('filters/setSeoEventList', val)
      }
    }, // end of the SET actions
    // ------------------
    get: { // begin of the GET actions
      campaign () {
        return store.getters['filters/getSelectedCampaign']
      },
      brand () {
        return store.getters['filters/getSelectedBrand']
      },
      date () {
        return store.getters['filters/getSelectedDate']
      },
      objective () {
        return store.getters['filters/getSelectedObjective']
      },
      domain () {
        return store.getters['filters/getSelectedDomain']
      },
      seoBrand () {
        return store.getters['filters/getSelectedSeoBrand']
      },
      seoMonth(val) {
        return store.getters['filters/getSelectedSeoMonth']
      },
      event () {
        return store.getters['filters/getSelectedEvent']
      },
      eventWeb () {
        return store.getters['filters/getSelectedEventWeb']
      },
      growthEvent () {
        return store.getters['filters/getSelectedGrowthEvent']
      },
      brandList () {
        return store.getters['filters/getBrandList']
      },
      campaignList () {
        return store.getters['filters/getCampaignList']
      },
      objectiveList () {
        return store.getters['filters/getObjectiveList']
      },
      domainList () {
        return store.getters['filters/getDomainList']
      },
      seoBrandList () {
        return store.getters['filters/getSeoBrandList']
      },
      seoMonthList(val) {
        return store.getters['filters/getSeoMonthList']
      },
      eventList () {
        return store.getters['filters/getEventList']
        },
      eventWebList () {
        return store.getters['filters/getEventWebList']
      },
      growthEventList () {
        return store.getters['filters/getGrowthEventList']
      },
      isCampaignSelectionProper () {
        return store.getters['filters/getIsCampaignSelectionProper']
      },
      isReady () {
        return store.getters['filters/getIsReady']
      },
      isReadyMetrics () {
        return store.getters['filters/getIsReadyMetrics']
      },
      defaultBrand () {
        return store.getters['filters/getDefaultBrand']
      },
      defaultAllCampaign () {
        return store.getters['filters/getDefaultAllCampaign']
      },
      defaultSelectCampaign () {
        return store.getters['filters/getDefaultSelectCampaign']
      },
      defaultDate () {
        return store.getters['filters/getDefaultDate']
      },
      mediaFormData() {
        return store.getters['filters/getMediaFormData']
      },
      taxForm () {
        return store.getters['filters/getTaxForm']
      },
      isEdit () {
        return store.getters['filters/getIsEdit']
      },
      addTax(val) {
        return store.getters['filters/getAddTax']
      },
      seoDate () {
        return store.getters['filters/getSeoDate']
      },
      seoEvent () {
        return store.getters['filters/getSeoEvent']
      },
      seoEventList(val) {
        return store.getters['filters/getSeoEventList']
      }
    } // end of the GET actions
  }// end of the vuex store state action shortcuts
  // ------------------
  // METHODS

  const getFilters = async () => Vue.prototype.$http.get('global/filters', {
    params: {
      brand_id: that.store.get.brand().value
    }
  }).then(
    async ({ data: { brandFilter, campaignFilter } }) => {
      that.store.set.brandList(brandFilter)
      if (campaignFilter.length === 0) {
        that.store.set.campaignList([that.store.get.defaultAllCampaign()])
      } else if (that.config.flags.allThings === false) {
        that.store.set.campaignList(campaignFilter)
       // await that.methods.getObjectiveFilterData()
       //  await that.methods.getEventFilterData()
       // await that.methods.getEventWebFilterData()
       // await that.methods.getGrowthEventFilterData()
        await that.methods.getAdditionalFilterData();



      } else {
        that.store.set.campaignList([that.store.get.defaultAllCampaign(), ...campaignFilter])
      }
      if (that.config.flags.allThings === false) {
        that.methods.allBrandsDeletion()
      }
      return true
    }
  )


  const getSeoBrandFilterData = async () => {
    const path = window.location.pathname.split("/").pop()
    if ((path === 'overview' || path === 'goals' || path === 'organicTraffic' || path === 'engagementBehaviour' || path === 'competitors' || path === 'outreachPerformance' || path === 'comparison')
         &&
        window.location.pathname.split("/")[1] === 'seo') {
      try {
        const {data} = await Vue.prototype.$http.get('/global/filters/additional', {
          params: {
            pageName: 'seo-overview'
          }
        });
        that.store.set.seoBrandList(data.brandFilter);
        that.store.set.seoBrand(data.brandFilter[0]);
        await that.methods.getAdditionalFilterData();
      } catch (error) {
        console.error('Error fetching seoBrand filter data:', error);
      }
    }
  }

    const getAdditionalFilterData = async () => {
    const path = window.location.pathname.split("/").pop()
    if(path === 'smartOptimization') {
      if(that.store.get.campaign().title === "Select a Campaign"){
       const campaignList = that.store.get.campaignList();
        that.store.set.campaign(campaignList[0])
      }
      try {
        const { data } = await Vue.prototype.$http.get('/global/filters/additional', {
          params: {
            brand_id: that.store.get.brand().value,
            adin_id: that.store.get.campaign().value,
            pageName: 'smartOptimization'
          }
        });

        that.store.set.objectiveList(data);
        that.store.set.objective(data[0]);
      } catch (error) {
        console.error('Error fetching objective filter data:', error);
      }
    }  else if ((path === 'overview' || path === 'goals' || path === 'organicTraffic' || path === 'engagementBehaviour' || path === 'competitors' || path === 'outreachPerformance' || path === 'comparison') &&
        that.store.get.seoBrandList() &&
        window.location.pathname.split("/")[1] === 'seo') {
      try {
        const { data } = await Vue.prototype.$http.get('/global/filters/additional', {
          params: {
            brand_id: that.store.get.seoBrand().value,
            pageName: 'seo-overview'
          }
        });
        that.store.set.domainList(data.domainFilter);
        that.store.set.seoMonthList(data.monthFilter);
        that.store.set.domain(data.domainFilter[0]);
        that.store.set.seoMonth(data.monthFilter[0]);
        that.store.set.seoEventList(data.eventFilter)
        that.store.set.seoEvent(data.eventFilter[0])
      } catch (error) {FilterEngine
        console.error('Error fetching domain filter data:', error);
      }
    } else if ((path === 'growth-overview' || path === 'app' || path === 'web') && window.location.pathname.split("/")[1] === 'growth-intelligence') {

      const { data } = await Vue.prototype.$http.get('/global/filters/additional', {
        params: {
          adin_id: that.store.get.campaign().value,
          brand_id: that.store.get.brand().value,
          pageName: 'growth-overview'
        }
      });
      that.store.set.growthEventList(data.events);
      that.store.set.growthEvent(data.events[0]);
    } else if (path === 'app-transaction') {

      const { data } = await Vue.prototype.$http.get('/global/filters/additional', {
        params: {
          adin_id: that.store.get.campaign().value,
          pageName: 'conversion-overview',
          sourceType: 'app'
        }
      });
      that.store.set.eventList(data.eventNames);
      that.store.set.event(data.eventNames[0]);
    } else if (path === 'web-transaction') {

      const { data } = await Vue.prototype.$http.get('/global/filters/additional', {
        params: {
          adin_id: that.store.get.campaign().value,
          pageName: 'conversion-overview',
          sourceType: 'web'
        }
      });
      that.store.set.eventWebList(data.eventNames);
      that.store.set.eventWeb(data.eventNames[0]);
    }
  }




  const getFilterFirsts = async () => Vue.prototype.$http.get('global/filters/firsts').then(
    async ({ data: { brand, campaign } }) => {
      that.store.set.campaign(campaign)
      that.store.set.brand(brand)
      await that.methods.getFilters()
    }
  )
  // ---- initializeFilterComponent Function ----
  // This function designed for the initializing to the Filter Component according to some conditions.
  // The description of the allThings flag is where it is defined.
  // The conditions are listed below.
  // *. allThings => true :: if the filter values are pre-selected, check whether they are all****. If it is, fix.
  //    If the filter values are not pre-selected, get the firsts data from API.
  // *. allThings => false :: if the filter values are pre-selected, do not anything. If they are not pre-selected,
  //    set as default values.
  const initializeFilterComponent = async () => {
    const path = window.location.pathname.split("/").pop()
    that.store.set.isReady(false);
    if ((path === 'overview' || path === 'goals' || path === 'organicTraffic' || path === 'engagementBehaviour' || path === 'competitors' || path === 'outreachPerformance' || path === 'comparison') &&
        that.store.get.seoBrandList() &&
        window.location.pathname.split("/")[1] === 'seo') {
        await that.methods.getSeoBrandFilterData();
    }
    await that.methods.getFilters()
    await that.methods.getSeoBrandFilterData();
    await that.methods.getAdditionalFilterData();
      if (that.config.flags.allThings === false) {
      if (that.store.get.brand().title === that.store.get.defaultBrand().title) {
        await that.methods.getFilterFirsts();
      } else if (
          that.store.get.campaign().title === that.store.get.defaultAllCampaign().title ||
          that.store.get.campaign().title === that.store.get.defaultSelectCampaign().title
      ) {
        const firstElementCampaignList = that.store.get.campaignList()[0];
        that.store.set.campaign(firstElementCampaignList);
      }
    } else if (that.store.get.campaign().title === that.store.get.defaultSelectCampaign().title) {
      that.store.set.campaign(that.store.get.defaultAllCampaign());
    }

    await that.methods.executeGetMetrics();
    that.store.set.isReady(true)
  }


  this.methods = {
    initializeFilterComponent,
    getFilters,
    getFilterFirsts,
    getSeoBrandFilterData,
    getAdditionalFilterData,
    resetStates () {
      that.store.set.campaign(null)
      that.store.set.campaignList(null)
      that.store.set.brand(null)
      that.store.set.brandList(null)
      that.store.set.date(null)
      that.store.set.isReady(false)
      that.store.set.isReadyMetrics(false)
    },
    appInitializer () {
      if (that.store.get.campaign() === null) {
        that.store.set.campaign(that.store.get.defaultAllCampaign())
      }

      if (that.store.get.brand() === null) {
        that.store.set.brand(that.store.get.defaultBrand())
      }

      if (that.store.get.date() === null) {
        that.store.set.date(that.store.get.defaultDate())
      }
      if(that.store.get.seoDate() === null) {
        that.store.set.seoDate(that.store.get.defaultDate())
      }
    },
    allBrandsDeletion () {
      const brandList = that.store.get.brandList()
      brandList.shift()
      that.store.set.brandList(brandList)
    },
    async executeGetMetrics () {
      if (that.config.getMetricsFunc !== undefined) {
        try {
          await that.config.getMetricsFunc()
        } catch (e) {
          console.log(e)
        }
      } else {
        console.error('There is no found getMetrics function handle.')
      }
    },
    getKeyForHighlights () {
      return that.store.get.brand().value + that.store.get.campaign().value
    }
  }
  // ------------------
  // ACTION

  this.actions = {
    async selectionBrand ({ title, value }) {
      that.store.set.brand({ title, value })
      await that.methods.getFilters().then(() => {
        if (that.config.flags.allThings === true) {
          that.store.set.campaign(that.store.get.defaultAllCampaign())
        } else {
          that.store.set.campaign(that.store.get.defaultSelectCampaign())
        }
      })
      const nowCampaign = that.store.get.campaign()
      that.store.set.date({ startDate: nowCampaign.startDate, endDate: nowCampaign.endDate })
      if (!that.config.flags.isCampaignNecessary) {
        await that.methods.executeGetMetrics()
      }
    },
    async selectionCampaign(campaign) {
      that.store.set.campaign(campaign);

      await that.methods.getAdditionalFilterData();
      await that.methods.executeGetMetrics();
    },
    async selectionDate (selectedDate) {
      that.store.set.date(selectedDate)
      await that.methods.executeGetMetrics()
    },
    async selectionObjective (selectedObjective) {
      that.store.set.objective(selectedObjective)
      await that.methods.executeGetMetrics()
    },
    async selectionDomain(selectedDomain) {
      that.store.set.domain(selectedDomain)
      await that.methods.executeGetMetrics()
    },
    async selectionSeoBrand(selectedSeoBrand) {
      that.store.set.seoBrand(selectedSeoBrand)
      await that.methods.executeGetMetrics()
    },
    async selectionSeoMonth(selectedSeoMonth) {
      that.store.set.seoMonth(selectedSeoMonth)
      await that.methods.executeGetMetrics()
    },
    async selectionSeoEvent(selectedSeoEvent) {
      that.store.set.seoEvent(selectedSeoEvent)
      await that.methods.executeGetMetrics()
    },
    async selectionEvent(selectedEvent) {
      that.store.set.event(selectedEvent)
      await that.methods.executeGetMetrics()
    },
    async selectionEventWeb(selectedEventWeb) {
      that.store.set.eventWeb(selectedEventWeb)
      await that.methods.executeGetMetrics()
    },
    async selectionGrowthEvent(selectedGrowthEvent) {
        that.store.set.growthEvent(selectedGrowthEvent)
        await that.methods.executeGetMetrics()
    },
    async selectionSeoDate (selectedSeoDate) {
      that.store.set.seoDate(selectedSeoDate)
      await that.methods.executeGetMetrics()
    },
  }

  // ShortCuts
  this.isReady = () => that.store.get.isReady()
  this.isReadyMetrics = () => that.store.get.isReadyMetrics()
  this.getMetrics = funHandle => {
    that.config.getMetricsFunc = funHandle
  }
  this.updateFlags = flags => {
    that.config.flags = { ...that.config.flags, ...flags }
  }
}

const filterEngine = new FilterEngine()

Vue.prototype.$filter = filterEngine

export default FilterEngine
